// src/features/campaign/campaignMetricsSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import { apiEndpoints } from "../../services/apiConfig";

// Async thunk to fetch campaign metrics
// Async thunk to fetch campaign metrics
export const fetchCampaignMetrics = createAsyncThunk(
  "campaign/fetchMetrics",
  async (campaignId, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        apiEndpoints.getCampaignMetrics(campaignId),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchCampaignRecipients = createAsyncThunk(
  "campaign/fetchRecipients",
  async (campaignId, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        apiEndpoints.getCampaignRecipients(campaignId),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);



const campaignMetricsSlice = createSlice({
  name: "campaignMetrics",
  initialState: {
    metrics: null,
    loading: false,
    error: null,
    datarecipients: []
  },
  reducers: {
    clearMetrics: (state) => {
      state.metrics = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCampaignMetrics.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCampaignMetrics.fulfilled, (state, action) => {
        state.loading = false;
        state.metrics = action.payload;
      })
      .addCase(fetchCampaignMetrics.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchCampaignRecipients.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCampaignRecipients.fulfilled, (state, action) => {
        state.loading = false;
        state.datarecipients = action.payload;
      })
      .addCase(fetchCampaignRecipients.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearMetrics } = campaignMetricsSlice.actions;
export default campaignMetricsSlice.reducer;
